import './styles/master.scss';
import '@yzfe/svgicon/lib/svgicon.css';
import 'intersection-observer';
import { createHead } from '@unhead/vue';
import { VueSvgIconPlugin } from '@yzfe/vue-svgicon';
import { vMaska } from 'maska/vue';
import { createPinia } from 'pinia';
import { createApp } from 'vue';
import { registerBaseComponents } from '@components/_globals';
import { createSanitizedSentryPiniaPlugin, initSentry } from '@utils/sentry';
import App from './App.vue';
import ClickAwayDirective from './directives/click-away';
import LazyLoadDirective from './directives/lazy-src';
import AnimationRevealDirective from './directives/reveal';
import ScrolledIntoViewDirective from './directives/scrolled-into-view';
import router from './router';

/*eslint-disable @typescript-eslint/no-explicit-any */
declare global {
	interface Window {
		AppleID: any;
		AwsWafCaptcha: any;
		AwsWafIntegration: any;
		awsWafCookieDomainList: string[];
		Persona: any;
		Intercom: any;
		Calendly: any;
		dataLayer: any;
		fbq: any;
		ga: any;
		google: any;
		gtag: any;
		hj: any;
		letterpress: any;
		pdst: any;
		prerenderReady: boolean;
		twttr: any;
		uetq: any;
		Plaid: any;
		initMap: any;
		Osano?: import('types/osano').OsanoGlobal;
		SENTRY_RELEASE: { id: string }; // auto-injected by Sentry webpack plugin
	}
}
/*eslint-enable @typescript-eslint/no-explicit-any */

/* hasOwn polyfill for older browsers, https://fundrise.sentry.io/issues/7048841124 */
if (!Object.hasOwn) {
	Object.hasOwn = (obj, prop) => Object.prototype.hasOwnProperty.call(obj, prop);
}

const app = createApp(App);

registerBaseComponents({ app });

const head = createHead();
app.use(head);

app.use(VueSvgIconPlugin, {
	tagName: 'SvgIcon',
	isOriginalDefault: true
});

app.directive('reveal', AnimationRevealDirective);
app.directive('lazy', LazyLoadDirective);
app.directive('click-away', ClickAwayDirective);
app.directive('scrolled-into-view', ScrolledIntoViewDirective);
app.directive('maska', vMaska);

const pinia = createPinia();
pinia.use(createSanitizedSentryPiniaPlugin());
app.use(pinia);

initSentry(app);

app.use(router);

app.mount('#app');
